// Subscription detection logic

const productInfoContainer = document.querySelector('.product__info-container');
const productPrice = productInfoContainer ? productInfoContainer.getAttribute('data-productprice') : null;
const productComparePrice = productInfoContainer ? productInfoContainer.getAttribute('data-productcompareprice') : null;
const isBundle = productInfoContainer ? productInfoContainer.getAttribute('data-isbundle')?.includes('Bundles') : false;
const isTandoor = document.querySelector('.template-product-tandoor-bundles') ? true : false;
const isPreOrder =  productInfoContainer?.getAttribute('data-ispreorder');
const isAvailable =  productInfoContainer?.getAttribute('data-isavailable');
const addToCartText = document.querySelector('.addToCartText');
const addToCartOriginalText = addToCartText?.textContent;

const addToCartComparePrice = document.querySelector('.addToCartComparePrice');
const addToCartPrice = document.querySelector('.addToCartPrice');

let onSubscription = false;
let currentQuantity = 1;
let quantityDiscount = 1;
let subscriptionDiscount = 0.85;

const checkSubscriptionState = () => {
  const subscriptionWidget = document.querySelector('recharge-subscription-widget');
  if (!subscriptionWidget) return false;

  const shadowRoot = subscriptionWidget.shadowRoot;
  if (!shadowRoot) return false;
  
  const selectedOption = shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
  onSubscription = selectedOption ? selectedOption.classList.contains('rc-purchase-option__subscription') : false;
  
  return onSubscription;
};

const getCurrentQuantity = () => {
  const checkedElement = document.querySelector('.var_title.checked');
  if (checkedElement) {
    return parseInt(checkedElement.getAttribute('data-quantity')) || 1;
  }
  return 1;
};

// Update widget prices when quantity changes

const originalWidgetPrices = {};

const updateRechargeWidgetPrices = () => {
  const widget = document.querySelector('recharge-subscription-widget');
  if (!widget || !widget.shadowRoot) return;

  const selectors = {
    base: '.rc-purchase-option:not([class*="subscription"]) .rc-price:not(.strike-through)',
    compare: '.rc-price.strike-through',
    subscription: '.rc-purchase-option[class*="subscription"] .rc-price:not(.strike-through)'
  };

  Object.entries(selectors).forEach(([key, selector]) => {
    const span = widget.shadowRoot.querySelector(selector);
    if (!span) return;

    const priceNode = span.childNodes.length === 1
      ? span
      : Array.from(span.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim().includes('$'));

    if (!priceNode) return;
    if (!(key in originalWidgetPrices)) {
      console.log('this is step originao')
      const match = priceNode.textContent.match(/\$[\s]*([\d.]+)/);
      if (!match || match.length < 2) return;
      console.log('this is step 1')
      const baseValue = parseFloat(match[1]);
      if (isNaN(baseValue)) return;
      originalWidgetPrices[key] = baseValue;
    }

    // Check if this is a subscription price or compare price
    const isSubscriptionPrice = key.toLowerCase().includes('subscription');
    const isComparePrice = key === 'compare';

    // Apply different calculation based on price type
    let newPrice;
    if (isSubscriptionPrice) {
      // Case 1: Subscription price - apply Shopify's distribution method
      const basePrice = originalWidgetPrices['base'] || originalWidgetPrices[key];
      const basePriceCents = Math.round(basePrice * 100);

      // Step 1: Apply 15% subscription discount per unit
      const priceAfterSubCents = Math.round(basePriceCents * 0.85);

      // Step 2: Calculate total after subscription
      const totalAfterSubCents = priceAfterSubCents * currentQuantity;

      // Step 3: Apply Shopify discount based on quantity
      let shopifyDiscountPercentage = 0;
      if (currentQuantity === 6) {
        shopifyDiscountPercentage = 5;
      } else if (currentQuantity === 8) {
        shopifyDiscountPercentage = 10;
      }

      let finalTotalCents;
      if (shopifyDiscountPercentage > 0) {
        const totalDiscountAmount = totalAfterSubCents * shopifyDiscountPercentage / 100;
        const perUnitDiscountCents = Math.floor(totalDiscountAmount / currentQuantity);
        const finalPricePerUnit = priceAfterSubCents - perUnitDiscountCents;
        finalTotalCents = finalPricePerUnit * currentQuantity;
      } else {
        finalTotalCents = totalAfterSubCents;
      }

      newPrice = (finalTotalCents / 100).toFixed(2);
    } else if (isComparePrice) {
      // Case 2: Compare price - no quantity discount applied
      newPrice = (originalWidgetPrices[key] * currentQuantity).toFixed(2);
    } else {
      // Case 3: Regular price - apply Shopify's distribution method for quantity discount
      const basePriceCents = Math.round(originalWidgetPrices[key] * 100);
      const totalCents = basePriceCents * currentQuantity;

      let discountPercentage = 0;
      if (currentQuantity === 4) {
        discountPercentage = 5;
      } else if (currentQuantity === 6) {
        discountPercentage = 10;
      }

      let finalTotalCents;
      if (discountPercentage > 0 && !isBundle && !isTandoor) {
        const totalDiscountAmount = totalCents * discountPercentage / 100;
        const perUnitDiscountCents = Math.floor(totalDiscountAmount / currentQuantity);
        const finalPricePerUnit = basePriceCents - perUnitDiscountCents;
        finalTotalCents = finalPricePerUnit * currentQuantity;
      } else {
        finalTotalCents = totalCents;
      }

      newPrice = (finalTotalCents / 100).toFixed(2);
    }

    priceNode.textContent = `$${newPrice}`;
  });
};


const setPrices = () => {
  currentQuantity = getCurrentQuantity();
  checkSubscriptionState();

  if (currentQuantity === 4) {
    quantityDiscount = 0.95;
    subscriptionDiscount = 0.85;
  } else if (currentQuantity === 6) {
    quantityDiscount = 0.9;
    subscriptionDiscount = 0.85 * 0.95;
  } else {
    quantityDiscount = 1;
    subscriptionDiscount = 0.85;
  }

  if(isBundle || isTandoor) {
    quantityDiscount = 1;
  }

  if(onSubscription) {
    if (!isPreOrder && isAvailable) {
      addToCartText.textContent = 'SUBSCRIBE';
    }
  } else {
    addToCartText.textContent = addToCartOriginalText;
  }

  const productPriceCents = Math.round(productPrice * 100);
  const productComparePriceCents = productComparePrice ? Math.round(productComparePrice * 100) : null;

  if(onSubscription) {
    if(addToCartComparePrice && productComparePriceCents) {
      addToCartComparePrice.textContent = '$' + ((productComparePriceCents * currentQuantity) / 100).toFixed(2);
    } else if(addToCartComparePrice) {
      addToCartComparePrice.textContent = '$' + ((productPriceCents * currentQuantity) / 100).toFixed(2);
    }

    if(addToCartPrice) {
      const priceAfterSubCents = Math.round(productPriceCents * 0.85);
      const totalAfterSubCents = priceAfterSubCents * currentQuantity;

      let shopifyDiscountPercentage = 0;
      if (currentQuantity === 6) {
        shopifyDiscountPercentage = 5;
      } else if (currentQuantity === 8) {
        shopifyDiscountPercentage = 10;
      }

      let finalTotalCents;
      if (shopifyDiscountPercentage > 0) {
        const totalDiscountAmount = totalAfterSubCents * shopifyDiscountPercentage / 100;
        const perUnitDiscountCents = Math.floor(totalDiscountAmount / currentQuantity);
        const finalPricePerUnit = priceAfterSubCents - perUnitDiscountCents;
        finalTotalCents = finalPricePerUnit * currentQuantity;
      } else {
        finalTotalCents = totalAfterSubCents;
      }

      addToCartPrice.textContent = '$' + (finalTotalCents / 100).toFixed(2);
    }
  } else {
    if(addToCartComparePrice && productComparePriceCents) {
      addToCartComparePrice.textContent = '$' + ((productComparePriceCents * currentQuantity) / 100).toFixed(2);
    } else if(addToCartComparePrice) {
      addToCartComparePrice.textContent = '$' + ((productPriceCents * currentQuantity) / 100).toFixed(2);
    }

    if(addToCartPrice) {
      const totalCents = productPriceCents * currentQuantity;

      let discountPercentage = 0;
      if (currentQuantity === 4) {
        discountPercentage = 5;
      } else if (currentQuantity === 6) {
        discountPercentage = 10;
      }

      let finalTotalCents;
      if (discountPercentage > 0 && !isBundle && !isTandoor) {
        const totalDiscountAmount = totalCents * discountPercentage / 100;
        const perUnitDiscountCents = Math.floor(totalDiscountAmount / currentQuantity);
        const finalPricePerUnit = productPriceCents - perUnitDiscountCents;
        finalTotalCents = finalPricePerUnit * currentQuantity;
      } else {
        finalTotalCents = totalCents;
      }

      addToCartPrice.textContent = '$' + (finalTotalCents / 100).toFixed(2);
    }
  }

  if (addToCartComparePrice && addToCartPrice && addToCartComparePrice.textContent === addToCartPrice.textContent) {
    addToCartComparePrice.textContent = '';
  }

  // Handle bundle display
  if(isBundle) {
    document.querySelectorAll('.product .variant_lists .vartitleDiscount').forEach(el => {
      el.style.display = 'none';
    });
    document.querySelectorAll('.product .variant_lists .vartitleDiscountSubscription').forEach(el => {
      el.style.display = onSubscription ? 'flex' : 'none';
    });
  } else {
    document.querySelectorAll('.product .variant_lists .vartitleDiscount').forEach(el => {
      el.style.display = onSubscription ? 'none' : 'flex';
    });
    document.querySelectorAll('.product .variant_lists .vartitleDiscountSubscription').forEach(el => {
      el.style.display = onSubscription ? 'flex' : 'none';
    });
  }

  updateRechargeWidgetPrices();
};

// Start continuous price updates
setInterval(setPrices, 300);







// Styles logic
const applyStyles = (shadow) => {
  const style1 = document.createElement('style');
  style1.textContent = `
    .rc-purchase-option {
      border: none !important;
      background: transparent !important;
      margin-bottom: 0 !important;
    }

    .compact.rc-selection__root {
      font-family: 'Masqualero', sans-serif !important;
      font-size: 20px !important;
    }

   

    .rc-purchase-option__badge {
      display: none;
    }

    .compact .rc-purchase-option__prices {
      flex-direction: row !important;
      gap: 8px;
      align-items: center !important;
    }

    @media screen and (max-width: 768px) {
      .compact .rc-purchase-option__prices {
        flex-direction: column !important;
        gap: 0px;
        align-items: stretch !important;
      }

       .compact.rc-selection__root {
        font-size: 17px !important;
      }
    }

    .compact .rc-purchase-option__label {
      border-top: 1px dotted rgba(0, 0, 0, 0.12);
      padding: 14px 0 !important;
      flex-wrap: wrap;
    }

    @media screen and (max-width: 768px) {
      .compact .rc-purchase-option__label {
        font-size: 17px !important;
      }
    }
  

    .rc-purchase-option__subscription .rc-price::after {
      margin-left: 0px;
    }

    .rc-price.strike-through {
      color: rgba(0, 31, 25, 0.70);
      text-align: center;
      font-family: Masqualero;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      text-decoration-line: line-through;
      margin-top: 1px;
    }

    @media screen and (max-width: 768px) {
      .rc-price.strike-through {
        text-align: right;
        margin-top: 0px;
      }
    }

    .rc-price.strike-through::after {
      display: none;
    }

    .compact rc-learn-more {
      display: flex;
    }

    rc-learn-more::after {
      content: 'RECOMMENDED';
      color: #fff;
      text-align: center;
      font-family: Avenir, 'TTNorms';
      font-size: 12px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      text-transform: uppercase;
      display: flex;
      padding: 6px 14px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 78px;
      background: #DC4C55;
    }

    @media screen and (max-width: 768px) {
      rc-learn-more::after {
        background: #DC4C55;
        position: absolute;
        top: 50px;
        left: 0;
        font-size: 9.3px;
      }
    }

    @media screen and (max-width: 768px) {
      .rc-purchase-option__subscription > .rc-purchase-option__label {
        padding-bottom: 50px !important; 
      }
    }

    .rc-purchase-option__sub-container {
      padding-inline: 0 !important;
      padding-bottom: 16px !important;
      border-bottom: 1px dotted rgba(0, 0, 0, 0.12);
      gap: 12px !important;
    }

    .rc-purchase-option__sub-container::after {
      content: 'Our flexible subscription has no minimum term and can be cancelled or adjusted at any time.';
      color: #000;
      font-family: "TTNorms";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }

    .rc-purchase-option__selector {
      font-size: 16px !important;
    } 

    .fixedOnScroll {
      position: fixed !important;
      bottom : 23px !important;
      left: 300px !important;
      z-index: 100 !important;
      background: white !important;
      transition: all 0.3s ease !important;
    }

    @media screen and (max-width: 1300px) {
      .fixedOnScroll {
        left: 200px !important;
      }
    }

     @media screen and (max-width: 1220px) {
      .fixedOnScroll {
        bottom: 0px !important;
      }
    }

     @media screen and (max-width: 990px) {
      .fixedOnScroll {
        bottom: 134px !important;
        left: 0 !important;
        width: 100%;
        padding: 0 22px;
        box-sizing: border-box;

      }

      .fixedOnScroll .rc-purchase-option {
        width: 100%;
      }
    }


    .fixedOnScroll .compact.rc-selection__root {
      display: flex !important;
      align-items: center !important;
      gap: 20px !important;
    }

     @media screen and (max-width: 1220px) {
      .fixedOnScroll .compact.rc-selection__root {
        gap: 0px !important;
        align-items: flex-start !important;
      }
    }

     @media screen and (max-width: 990px) {
      .fixedOnScroll .compact.rc-selection__root {
        gap: 8px !important;
      }
    }

    .fixedOnScroll .rc-purchase-option__selector {
      height: 33px;
    }

    .fixedOnScroll .rc-purchase-option__sub-container::after {
      display: none !important; 
    }

    .fixedOnScroll .compact .rc-purchase-option__prices {
      display: none !important;
    }

    .fixedOnScroll .rc-purchase-option__subscription {
      display: flex !important;
      align-items: center !important;
    }

    @media screen and (max-width: 1220px) {
      .fixedOnScroll .rc-purchase-option__subscription {
        flex-direction: column !important;
      }
    }

     @media screen and (max-width: 990px) {
      .fixedOnScroll .rc-purchase-option__subscription {
        position: static !important;
      }
    }

    .fixedOnScroll .rc-purchase-option__sub-container {
        padding: 20px !important;
        justify-content: center;
        border: 0;
    }

    @media screen and (max-width: 990px) {
      .fixedOnScroll .rc-purchase-option__sub-container {
          padding: 0px 20px !important;
          position: absolute;
          bottom: -48px;
          left: 0;
          width: 100%;
          box-sizing: border-box;
      }

      .fixedOnScroll .rc-purchase-option__label {
        border: none !important;
      }

      .fixedOnScroll .rc-purchase-option{
        border: 1px solid rgba(0, 0, 0, 0.12) !important;
      }
    }

    .fixedOnScroll .rc-purchase-option__sub-container .rc-plans-dropdown__select{
        border: none !important;
    }

    .fixedOnScroll rc-learn-more::after {
      content: '15% OFF' !important;
    }

    @media screen and (max-width: 990px) {
      .fixedOnScroll rc-learn-more::after{
        top: -11px;
        left: 64%;
      }
    }

    .fixedOnScroll .compact .rc-purchase-option__label {
      border: 1px solid rgba(0, 0, 0, 0.12);
      padding: 10px 20px !important;
      height: 40px !important;
    }


  `;
  shadow.appendChild(style1);

  // now we wait for the inner shadow
  const waitForInner = setInterval(() => {
    const sellingPlans = shadow.querySelector('rc-selling-plans');
    const innerShadow = sellingPlans?.shadowRoot;

    if (innerShadow) {
      const dropdown = innerShadow.querySelector('.rc-plans-dropdown__select');
      if (dropdown) {
        const style2 = document.createElement('style');
        style2.textContent = `
          .rc-plans-dropdown__select {
            font-family: 'TTNorms', sans-serif !important;
            padding-block: 10px !important;
            border: 1px solid rgba(0, 0, 0, 0.13) !important;
            font-size: 14px !important;
          }
        `;
        innerShadow.appendChild(style2);
        clearInterval(waitForInner);
      }
    }
  }, 300);
};

const widget = document.querySelector('recharge-subscription-widget');

// Main initialization for styles
const waitForWidget = setInterval(() => {
  const shadow = widget?.shadowRoot;
  if (!shadow) return;

  const hasContent = shadow.querySelector('.rc-purchase-option');
  if (!hasContent) return;

  clearInterval(waitForWidget);

  // Apply styles
  applyStyles(shadow);
}, 300);




// TODO
// cambiar front build your bundle
// agregar / ajustar descuentos en shopify